import { useApplePayState, useIsApplePaylaterApplePayRepaymentEnabled } from '../../../../state'
import { ApplePayButton } from '../ApplePayButton'
import { Divider } from '@afterpaytouch/core'
import styles from './style.module.css'

export const ApplePayButtonHeading = () => {
  const isApplePaylaterApplePayEnabled = useIsApplePaylaterApplePayRepaymentEnabled()
  const { isEnabledForDevice } = useApplePayState()

  if (!isApplePaylaterApplePayEnabled || !isEnabledForDevice) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        <ApplePayButton />
      </div>
      <div className={styles.dividerContainer}>
        <Divider />
      </div>
    </div>
  )
}
